var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-content-buttons"},_vm._l((_vm.buttons),function(btn,i){return _c('btn',{key:("block-button-" + _vm._uid + "-" + i),attrs:{"tag":btn.tag,"href":btn.href,"label":btn.label,"modifier":btn.modifier,"icon":btn.icon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }